import { LoadingScreen } from "../../../shared/components/LoadingScreen";
import { useFileDownloadPage } from "./useFileDownloadPage";

export const FileDownloadPage = () => {
  const { downloadStarted, t } = useFileDownloadPage();

  if (downloadStarted) {
    return (
      <div className="min-h-screen flex items-center justify-center p-8">
        <p>{t("Your download has started.")}</p>
      </div>
    );
  }

  return <LoadingScreen message={t("Preparing download...")} />;
};
